import { Type } from 'class-transformer';
import { ARCreditApplicationTransactionItemParametersDto } from './ar-credit-application-transaction-item-parameters-dto';

export class ARCreditApplicationTargetParametersDto {
    targetId: number;
    @Type(() => ARCreditApplicationTransactionItemParametersDto)
    items: ARCreditApplicationTransactionItemParametersDto[];
}
